import type { PatientEpisodesResponse } from '../../services/api/types.gen';
import { formatDateToMMDDYYYY } from '../../utils/dateUtils';

export type AddEpisodeBlockedReason = NonNullable<
  PatientEpisodesResponse['add_episode_blocked_reason']
>;

/**
 * Why the chart's Add Episode control is disabled, in the words shown beside it.
 * A patient who never had an admission completes intake first; a
 * patient whose latest admission is discharged is re-admitted through intake.
 * Returns null when nothing blocks Add Episode (or the reason is not known yet).
 */
export function addEpisodeBlockedCopy(
  reason: AddEpisodeBlockedReason | null,
  dischargeDate: string | null
): string | null {
  if (reason === 'no_admission') return 'Complete intake first';
  if (reason === 'admission_discharged') {
    const formatted = formatDateToMMDDYYYY(dischargeDate);
    return formatted
      ? `Discharged ${formatted}. Admit through intake.`
      : 'Discharged. Admit through intake.';
  }
  return null;
}
